import {
  ANNUALLY,
  MONTHLY,
} from '../../../../../constants/upgradeJourney.constant';
import { readSubscriberCountry } from '../../../../../utils/common';

export const getFilterMonthlyAndYearly = (eligiblePlans) => {
  const filterMonthlyAndYearly = eligiblePlans.reduce(
    (all, item) => {
      if (item?.BillingCycle?.toLowerCase() === MONTHLY) {
        all.monthly.push(item);
      } else if (item.BillingCycle?.toLowerCase() === ANNUALLY) {
        all.yearly.push(item);
      } else {
        all.otherBillingCycle.push(item);
      }
      return all;
    },
    { monthly: [], yearly: [], otherBillingCycle: [] },
  );

  return filterMonthlyAndYearly;
};

export const getRetrieveEligibilityResponseUiModel = (responseData) => {
  if (!Object.keys(responseData).length) {
    return {};
  }

  const getEnableFeatureItemList = (featureCategoriesItems) =>
    (featureCategoriesItems || []).reduce(
      (initialFeatureList, featureItem) => {
        const enabledFeatureItemList = featureItem?.enabledFeatures?.items;
        if (
          enabledFeatureItemList?.length &&
          !initialFeatureList.featureItemAvailable
        ) {
          const descriptionList = enabledFeatureItemList.map(
            (featureItem) => featureItem.description,
          );
          initialFeatureList.featureItemList.push(...descriptionList);
          initialFeatureList.featureItemAvailable = true;
        }
        return initialFeatureList;
      },
      { featureItemList: [], featureItemAvailable: false },
    );

  const getBillingCycleItems = (billingCycles, entitlementList) =>
    (billingCycles?.items || []).reduce(
      (InitialBillingCycle, billingCycleItem) => {
        const { eligiblePricingDetails, ctaLabel, label } = billingCycleItem;
        const enabledFeatureItems = getEnableFeatureItemList(
          entitlementList?.featureCategories?.items,
        ).featureItemList;
        InitialBillingCycle.push({
          ...eligiblePricingDetails,
          ...entitlementList,
          enabledFeatureItems,
          ctaLabel,
          label,
        });
        return InitialBillingCycle;
      },
      [],
    );

  const getEligiblePlansFromResponse = (eligiblePlansFromResponse) => {
    const eligiblePlans =
      eligiblePlansFromResponse?.rightsGroupProducts?.products?.items || [];
    if (!eligiblePlans.length) {
      return [];
    }
    const productItems = eligiblePlans.reduce((initialProduct, productItem) => {
      const { billingCycles, ...entitlementList } = productItem;
      const getFlattedProductItem = getBillingCycleItems(
        productItem?.billingCycles,
        entitlementList,
      );
      initialProduct.push(...getFlattedProductItem);
      return initialProduct;
    }, []);
    return productItems;
  };

  const constructRetrieveResponseUiModel = [{ ...responseData }].reduce(
    (all, item) => {
      all.EntitledPlans = item.entitledPlansSummary;
      all.EligiblePlans = getEligiblePlansFromResponse(
        item?.rightsGroupMetadata,
      );
      all.OriginCountry = item.originCountry;
      all.Partners = item.partners;
      all.Disclaimers =
        item.rightsGroupMetadata?.rightsGroupProducts?.disclaimers;
      return all;
    },
    {
      EligiblePlans: [],
      EntitledPlans: [],
      OriginCountry: '',
      Warnings: [],
    },
  );

  return constructRetrieveResponseUiModel;
};

export const upgradeSubscriptionEventPayload = ({
  language,
  selectedEligiblePlan,
}) => {
  const userCountry = readSubscriberCountry();
  const selectedLanguage = language;
  const subscriptionPackage =
    selectedEligiblePlan?.PricingPlanProperties?.Subscribedproduct;
  const subscriptionType = selectedEligiblePlan?.Name;

  return {
    subscriptionPackage,
    subscriptionType,
    userCountry,
    selectedLanguage,
  };
};
